import {createContext, useContext, useEffect, useState} from 'react'
import useCompanies from 'src/hooks/api/companies/useCompanies'
import {Company} from 'src/services/api/endpoints/CompanyEndpoint'

type CompanyData = {
  selectedCompanies: number[]
  setSelectedCompanies: (companyIds: number[]) => void
  selectedCompanyId: number
  setSelectedCompanyId: (id: number) => void
  getCompanyName: (companyId?: number) => string
  companies: Array<Company>
  fetchNextPage: () => void
}

function loadSelectedCompaniesState(): number[] {
  const savedState = localStorage.getItem('selectedCompaniesState')
  return savedState ? JSON.parse('[' + savedState + ']') : []
}

function loadSelectedCompanyState(): number {
  const savedState = localStorage.getItem('selectedCompanyState')
  return savedState ? Number(savedState) : 0
}

export type CompaniesMemo = {
  id: number
  name: string
}

export const CompanyContext = createContext({} as CompanyData)

export function CompanyProvider({children}: React.PropsWithChildren<any>) {
  const [selectedCompanies, setSelectedCompanies] = useState<number[]>(loadSelectedCompaniesState())
  const [selectedCompanyId, setSelectedCompanyId] = useState<number>(loadSelectedCompanyState())

  const {data, fetchNextPage} = useCompanies()
  const [companies, setCompanies] = useState<Array<Company>>([])

  useEffect(() => {
    const companies = data?.pages.flatMap((it) => it.entities) ?? []
    setCompanies(companies)
    if (!selectedCompanyId && companies.length) setSelectedCompanyId(companies[0].id)
    if (!selectedCompanies.length && companies.length) setSelectedCompanies(companies.map((it) => it.id))
  }, [data])

  const getCompanyName = (companyId?: number) => {
    if (!companyId) return ''
    const company = companies.find((company) => company.id === companyId)
    if (company) return company.name

    return 'Empresa não encontrada'
  }

  return (
    <CompanyContext.Provider
      value={{
        selectedCompanies,
        setSelectedCompanies,
        selectedCompanyId,
        setSelectedCompanyId,
        getCompanyName,
        companies,
        fetchNextPage,
      }}>
      {children}
    </CompanyContext.Provider>
  )
}

export function useCompany() {
  return useContext(CompanyContext)
}
